const PLAYER_PREFIX = '@PLAYER';

export const OPEN = `${PLAYER_PREFIX}/OPEN`;
export const CLOSE = `${PLAYER_PREFIX}/CLOSE`;
export const ERROR = `${PLAYER_PREFIX}/ERROR`;

export const ON_ENDED = `${PLAYER_PREFIX}/ON_ENDED`;

export const ON_START_PLAYING = `${PLAYER_PREFIX}/ON_START_PLAYING`;
export const ON_STOP_PLAYING = `${PLAYER_PREFIX}/ON_STOP_PLAYING`;
export const ON_TIME_UPDATE = `${PLAYER_PREFIX}/ON_TIME_UPDATE`;

export const NAVIGATE_TO_PLAYER_PAGE = `${PLAYER_PREFIX}/NAVIGATE_TO_PLAYER_PAGE`;

export const LOAD_DATA = `${PLAYER_PREFIX}/LOAD_DATA`;
export const LOAD_DATA_SUCCESS = `${PLAYER_PREFIX}/LOAD_DATA_SUCCESS`;
export const LOAD_DATA_ERROR = `${PLAYER_PREFIX}/LOAD_DATA_ERROR`;
